<template>
    <div class="row ml-xl-4 m-0">
        <div class="col-12">
            <h3>Impresos</h3>
        </div>
        <div class="col-12">
            <table v-if="impresos.length > 0" class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Fecha de impresión</th>
                        <th>Reimpresión</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(impreso, index) in impresos">
                        <tr :key="index">
                            <td class="w-25">{{ impreso.fecha_impresion}}</td>
                            <td>{{ impreso.reimpresion ? 'SI' : 'NO' }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <p v-else>
                Este socio no tiene abonos impresos.
            </p>
            <div v-if="impresos.length  > 0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  first-number
                  last-number
                ></b-pagination>
              </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['abonado'],
    data() {
        return {
            rows: 1,
            perPage: 1,
            currentPage: 1,
            impresos: [],
        }
    },
    mounted(){
        this.getImpresos();
    },
    methods: {
        getImpresos(){

            const data = {
                abonado_id: this.abonado.id,
                filters : {
                    page: this.currentPage,
                    abonado_id: this.abonado.id,
                },
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.abonado.impresion'), data).then(res => {
                this.rows = res.data.meta.last_page
                this.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                this.currentPage = res.data.meta.current_page
                this.impresos = res.data.data;
            }).catch(error => {
                this.$toast.error('Ha ocurrido un error.');
            });
        }
    },

    watch: {
        currentPage() {
            this.getImpresos();
        }
    }
    
}
</script>